module.exports = __webpack_public_path__ + "static/media/hat.b7079488.svg";